import orderBy from 'lodash/orderBy'

import { server } from '@/services/'

const state = {
  isFetching: false,
  cleanerHistories: [],
  stations: [],
  zones: [],
  carInStations: [],
  cars: [],
  cleaners: []
}

const mutations = {
  setIsFetching (state, payload) {
    state.isFetching = payload
  },
  setCleanerHistories (state, payload) {
    state.cleanerHistories = payload
  },
  setZones (state, payload) {
    state.zones = payload
  },
  setStations (state, payload) {
    state.stations = payload
  },
  setCars (state, payload) {
    state.cars = payload
  },
  setCarInStations (state, payload) {
    state.carInStations = payload
  },
  setCleaners (state, payload) {
    state.cleaners = payload
  }
}

const actions = {
  fetchZones ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getZones').then(
        resp => {
          let zones = resp.data.msgContent.data.map(zone => ({...zone, COLLAPSED: false}))
          commit('setZones', zones)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchStations ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getStations').then(
        resp => {
          let stations = resp.data.msgContent.data.map(station => ({...station, COLLAPSED: false}))
          commit('setStations', stations)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCars ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCars').then(
        resp => {
          commit('setCars', resp.data.msgContent.data)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCarInStations ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCarInStations').then(
        resp => {
          let carInStations = resp.data.msgContent.data.map(cist => ({...cist, COLLAPSED: false}))
          commit('setCarInStations', carInStations)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCleaners({commit}) {
    return new Promise((resolve, reject) => {
      server.get('/sso/getUA_Cleaners').then(
        resp => {
          commit('setCleaners', resp.data.msgContent.data)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCleanerHistory ({commit}, payload) {
    let url = ''

    if (payload.type === 0) {
      url = `/ops/rptCleaningLogs_Cleaner/1/${payload.uaCode}/${payload.date}`
    } else if (payload.type === 1) {
      url = `/ops/rptCleaningLogs_Cleaner/2/${payload.uaCode}/${payload.date}`
    } else {
      url = `/ops/rptCleaningLogs_Cleaner/3/${payload.uaCode}/${payload.date}`
    }

    return new Promise((resolve, reject) => {
      server.get(url).then(
        resp => {
          commit('setCleanerHistories', orderBy(resp.data.msgContent.data, 'LOG_DATE', 'desc'))
          resolve()
        },
        err => reject(err)
      )
    })
  },
  composeHistoryData ({commit, state}) {
    return new Promise((resolve) => {
      let composedCist = state.carInStations.map(cist => ({
        ...cist,
        STATION: state.stations.find(station => station.CODE === cist.STATION_CODE),
        CAR: state.cars.find(car => car.CODE === cist.CAR_CODE)
      }))
      let histories = state.cleanerHistories.map(history => {
        let cistTmp = composedCist.find(cist => cist.CODE === history.CAR_IN_STATION_CODE)
        if (cistTmp !== undefined) {
          return {...history, CIST: cistTmp}
        } else {
          return { ...history, CIST: {CAR: {}, STATION: {}} }
        }
      })
      commit('setCleanerHistories', histories)
      resolve()
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
